import { useState } from "react";
import { Globe, ChevronDown, Check } from "lucide-react";
import { REGIONS } from "@/lib/regions";
import { useRegion } from "@/context/RegionContext";

export default function RegionSelector({ align = "right" }) {
  const { region, setRegion } = useRegion();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative" data-testid="region-selector">
      <button onClick={() => setOpen((o) => !o)} data-testid="region-selector-button" aria-label="Choose your region"
        className="flex items-center gap-1.5 text-sm text-bone/70 hover:text-gold transition-colors">
        <Globe size={16} strokeWidth={1.75} />
        <span className="tabular-nums">{region.flag}</span>
        <span className="hidden lg:inline">{region.currency}</span>
        <ChevronDown size={13} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className={`absolute ${align === "right" ? "right-0" : "left-0"} mt-2 w-56 bg-surface border border-white/15 shadow-2xl shadow-black/50 z-50 py-1`} data-testid="region-menu">
            <p className="px-4 py-2 text-[10px] uppercase tracking-[0.2em] text-bone/40 border-b border-white/10">Your Region</p>
            {REGIONS.map((r) => (
              <button key={r.code} onClick={() => { setRegion(r.code); setOpen(false); }} data-testid={`region-option-${r.code}`}
                className={`w-full text-left px-4 py-2 text-sm flex items-center gap-2.5 hover:bg-white/5 transition-colors ${region.code === r.code ? "text-gold" : "text-bone/80"}`}>
                <span className="text-base leading-none">{r.flag}</span>
                <span className="flex-1">{r.label}</span>
                <span className="text-xs text-bone/40">{r.currency}</span>
                {region.code === r.code && <Check size={13} className="text-gold" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
